/**
 * token通用方法
 * Copyright (c) 2025 dfec
 */
import { SessionCache } from '@fanghub/tool-cache'
import type { PluginCache } from '@fanghub/tool-cache'

const cache: PluginCache<string | null> = new SessionCache<string | null>()
const TokenKey = 'Admin-Token'
/**
 * 获取token
 * @returns
 */
export function getToken(): string | null {
    return cache.getItem(TokenKey)
}

/**
 * 设置token
 * @param {Sting} token
 * @returns
 */
export function setToken(token: string): void {
    cache.setItem(TokenKey, token)
}

/**
 * 移除token
 * @returns
 */
export function removeToken(): void {
    cache.removeItem(TokenKey)
}
